<template>
  <div class="service">
    <div class="service-top">
      <van-search v-model="keyword" placeholder="请输入搜索关键词" />
      <div class="serviceList">
        <van-checkbox-group v-model="result">
          <van-cell v-for="(item,index) in serviceList" :key="item.id" @click="changeService(item, index)">
            <template #right-icon>
              <van-checkbox :name="item.id" ref="checkboxes" style="width: 100%">
                <!-- @click="changeService(item)" -->
                <div class="serviceDetail">
                  <img :src="require(`@/assets/serviceBg/${index > 13 ? index > 27 ? index-27 : index-13 : index+1}.jpg`)" fit="contain" alt="服务背景图" class="fuwu">
                  <span class="nowarp content">{{ item.productName }}</span>
                </div>
              </van-checkbox>
            </template>
          </van-cell>
        </van-checkbox-group>
      </div>
      <div class="store">所属用户：{{this.$route.query.username}}</div>
    </div>
    <div class="row align-center margin-left-40 margin-right-40 margin-bottom-20">
      <van-button type="info" round block @click="submit">录单</van-button>
    </div>
  </div>
</template>
<script>
  import { renderForm, getBillingPaymentType } from '@/api/extendedWarranty'
  import storage from '../../utils/storage'
  export default {
    data() {
      return {
        serviceList: [],
        products: [],
        uid: '',
        userName: '',
        keyword: '', // 产品搜索关键字
        result: []
      }
    },
    watch: {
      keyword: {
        handler(oldV) {
          if (oldV) {
            this.serviceList = this.products.filter(it => it.productName.includes(oldV))
          } else {
            this.serviceList = this.products
          }
        }
      }
    },
    created() {
      this.uid = this.$route.query.userid
      this.userName = ''
      this.getproduct()
      this.getPayType()
    },
    methods: {
       async getPayType() {
        const res = await getBillingPaymentType({ userId: Number(this.uid) })
        if (res.success) {
          const cont = res.content
          const payTypes = []
          cont.fullPayment && payTypes.push({ text: '全款', value: 0 }) 
          cont.installment && payTypes.push({ text: '分期', value: 1 }) 
          storage.setItem('PayType', payTypes)
        }
      },
      async getproduct() {
        if (!this.uid) {
          this.$toast.fail('账户ID不能为空')
          return
        }
        const res = await renderForm({ userId: Number(this.uid) })
        if (res && res.success) {
          this.serviceList = res.content.productList
          this.products = res.content.productList
          this.userName = res.content.userName
          this.storeName = res.content.storeName
          this.storeId = res.content.storeId
        }
      },
      changeService(item, index) {
        this.$refs.checkboxes[index].toggle()
      },
      submit() {
        if (!this.result || !this.result.length) {
          this.$toast('请选择产品')
          return
        }
        const selectProduct = this.products.filter(it => this.result.includes(it.id))
        storage.setItem('selectProduct', selectProduct)
        const order = storage.getItem('orderInfo')
        order && storage.clearItem('orderInfo')
        this.$router.push({ path: '/extended/create_order', query: { id: this.uid, userName: this.userName, storeName: this.storeName, storeId: this.storeId } })
      }
    }
  }
</script>
<style scoped>
  .service-top {
    min-height: calc(100vh - 60px);
  }
  .store {
    font-size: 14px;
    color: #666;
    margin: 0 auto;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 30px;
  }

  .fuwu {
    width: 100%;
    height: 100%;
    border-radius: 15px;
  }

  .title {
    width: 100%;
    text-align: center;
    font-size: 18px;
    line-height: 40px;
  }

  .serviceList {
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .serviceList /deep/ .van-checkbox__label {
    width: 100%;
  }

  .serviceDetail {
    position: relative;
    /* border: 1px solid #eee; */
    /* width: 90%; */
    height: 130px;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    margin-bottom: 10px;
  }

  .img {
    width: 50px;
    height: 50px;
    margin-right: 15px;
    /* background: #fff; */
    /* border-radius: 50%; */
  }

  .content {
    position: absolute;
    width: 90%;
    left: 20px;
    top: 20px;
    /* display: flex; */
    font-size: 18px;
    /* align-items: center; */
  }

  .nowarp {
    white-space: nowrap;
  }

</style>